import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { DetailedRecord } from "../../Container";
import { Records } from "./Component";

const RecordsContainer = (props) => {
  const { user, hasPermission, hasRecordPermission } = props;

  return (
    <Router basename="/glc/records">
      <Switch>
        <Route exact path="/">
          <Redirect to="/list" />
        </Route>
        <Route path="/list">
          <Records
            user={user}
            hasPermission={hasPermission}
            hasRecordPermission={hasRecordPermission}
          />
        </Route>
        <Route path="/viewRecord">
          <DetailedRecord
            user={user}
            hasPermission={hasPermission}
            hasRecordPermission={hasRecordPermission}
          />
        </Route>
      </Switch>
    </Router>
  );
};

export default RecordsContainer;
